import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";
import { useTranslations } from "../../../../providers/useTranslations";
import { useHeaderContext } from "../../context";
import styles from "./SecondaryNavigation.module.scss";
export const SecondaryNavigation = ({ children, className }) => {
    const { onClick } = useHeaderContext();
    const { __ } = useTranslations();
    return (_jsx("div", { className: classNames(styles.wrapper, className), children: _jsxs("div", { className: styles.innerWrapper, children: [children, _jsxs("button", { onClick: onClick, className: styles.closeButton, children: [__("navigation.button.close"), _jsx(ChevronUpIcon, {})] })] }) }));
};
//# sourceMappingURL=SecondaryNavigation.js.map